export default "type ForgotPasswordForm @form {\n  \"Enter your email\"\n  email: String! @input(type: \"email\")\n}\n";